"use client";
import { j as t } from "./jsx-runtime-CJ-St4mQ.mjs";
import { useRadioGroupContext as oe } from "./RadioGroupContext.js";
import { useRadioIndex as re } from "./RadioIndexContext.js";
import { t as se } from "./tv.config-BuYIgndg.mjs";
import { F as ne } from "./FieldLabel-C2NVcnds.mjs";
import * as a from "react";
import { c as ae, E as de, u as J } from "./useRenderElement-B8V3_e8R.mjs";
import { u as ie } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { v as le } from "./visuallyHidden-DPuANzJJ.mjs";
import { u as ce } from "./useBaseUiId-a-UPSsPQ.mjs";
import { N as ue } from "./noop-CMWc2wUO.mjs";
import { A as fe } from "./constants-BtlZRkCt.mjs";
import { C as pe } from "./CompositeItem-DhB3Tdag.mjs";
import { f as me, u as H } from "./FieldRootContext-Cj7-dNhd.mjs";
import { t as he } from "./useAnimationsFinished-DDpUuXkZ.mjs";
import { u as xe } from "./RadioGroupContext-CJkO5W0s.mjs";
import { u as be } from "./useButton-CQeWQM5o.mjs";
import { u as ge, a as ye } from "./useOpenChangeComplete-CXAVaIGe.mjs";
const ve = ({
  title: e,
  titleId: r,
  desc: l,
  descId: c,
  ...d
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": r,
    "aria-describedby": c,
    ...d,
    children: [
      l ? /* @__PURE__ */ t.jsx("desc", { id: c, children: l }) : null,
      e ? /* @__PURE__ */ t.jsx("title", { id: r, children: e }) : null,
      /* @__PURE__ */ t.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m7.95 12 2.7 2.7 5.4-5.4M21 12c0 4.9706-4.0294 9-9 9s-9-4.0294-9-9 4.0294-9 9-9 9 4.0294 9 9"
        }
      )
    ]
  }
);
let U = /* @__PURE__ */ function(e) {
  return e.checked = "data-checked", e.unchecked = "data-unchecked", e.disabled = "data-disabled", e.readonly = "data-readonly", e.required = "data-required", e.valid = "data-valid", e.invalid = "data-invalid", e.touched = "data-touched", e.dirty = "data-dirty", e.filled = "data-filled", e.focused = "data-focused", e;
}({});
const M = {
  checked(e) {
    return e ? {
      [U.checked]: ""
    } : {
      [U.unchecked]: ""
    };
  },
  ...he,
  ...me
}, O = /* @__PURE__ */ a.createContext(void 0);
process.env.NODE_ENV !== "production" && (O.displayName = "RadioRootContext");
function ke() {
  const e = a.useContext(O);
  if (e === void 0)
    throw new Error("Base UI: RadioRootContext is missing. Radio parts must be placed within <Radio.Root>.");
  return e;
}
const K = /* @__PURE__ */ a.forwardRef(function(r, l) {
  const {
    render: c,
    className: d,
    disabled: m = !1,
    readOnly: h = !1,
    required: u = !1,
    value: s,
    inputRef: b,
    nativeButton: j = !0,
    ...N
  } = r, {
    disabled: g,
    readOnly: y,
    required: E,
    checkedValue: Y,
    setCheckedValue: I,
    onValueChange: v,
    touched: P,
    setTouched: S,
    fieldControlValidation: w,
    registerControlRef: $
  } = xe(), {
    state: T,
    disabled: Q
  } = H(), n = Q || g || m, i = y || h, p = E || u, {
    setDirty: V,
    validityData: q,
    setTouched: B,
    setFilled: k
  } = H(), f = Y === s, C = a.useRef(null), F = ae(b, C);
  ie(() => {
    var o;
    (o = C.current) != null && o.checked && k(!0);
  }, [k]);
  const X = a.useMemo(() => ({
    role: "radio",
    "aria-checked": f,
    "aria-required": p || void 0,
    "aria-disabled": n || void 0,
    "aria-readonly": i || void 0,
    [fe]: f ? "" : void 0,
    disabled: n,
    onKeyDown(o) {
      o.key === "Enter" && o.preventDefault();
    },
    onClick(o) {
      var x;
      o.defaultPrevented || n || i || (o.preventDefault(), (x = C.current) == null || x.click());
    },
    onFocus(o) {
      var x;
      o.defaultPrevented || n || i || !P || ((x = C.current) == null || x.click(), S(!1));
    }
  }), [f, p, n, i, P, S]), {
    getButtonProps: Z,
    buttonRef: D
  } = be({
    disabled: n,
    native: j
  }), L = ce(), A = a.useMemo(() => ({
    type: "radio",
    ref: F,
    // Set `id` to stop Chrome warning about an unassociated input
    id: L,
    tabIndex: -1,
    style: le,
    "aria-hidden": !0,
    disabled: n,
    checked: f,
    required: p,
    readOnly: i,
    onChange(o) {
      o.nativeEvent.defaultPrevented || n || i || s === void 0 || (B(!0), V(s !== q.initialValue), I(s), k(!0), v == null || v(s, o.nativeEvent));
    }
  }), [f, n, L, v, i, F, p, I, V, B, k, q.initialValue, s]), R = a.useMemo(() => ({
    ...T,
    required: p,
    disabled: n,
    readOnly: i,
    checked: f
  }), [T, n, i, f, p]), ee = a.useMemo(() => R, [R]), _ = I !== ue, G = [l, $, D], z = [X, (w == null ? void 0 : w.getValidationProps) ?? de, N, Z], te = J("button", r, {
    enabled: !_,
    state: R,
    ref: G,
    props: z,
    customStyleHookMapping: M
  });
  return /* @__PURE__ */ t.jsxs(O.Provider, {
    value: ee,
    children: [_ ? /* @__PURE__ */ t.jsx(pe, {
      tag: "button",
      render: c,
      className: d,
      state: R,
      refs: G,
      props: z,
      customStyleHookMapping: M
    }) : te, /* @__PURE__ */ t.jsx("input", {
      ...A
    })]
  });
});
process.env.NODE_ENV !== "production" && (K.displayName = "RadioRoot");
const W = /* @__PURE__ */ a.forwardRef(function(r, l) {
  const {
    render: c,
    className: d,
    keepMounted: m = !1,
    ...h
  } = r, u = ke(), s = u.checked, {
    transitionStatus: b,
    setMounted: j
  } = ge(s), N = a.useMemo(() => ({
    ...u,
    transitionStatus: b
  }), [u, b]), g = a.useRef(null), y = m || s, E = J("span", r, {
    enabled: y,
    ref: [l, g],
    state: N,
    props: h,
    customStyleHookMapping: M
  });
  return ye({
    open: s,
    ref: g,
    onComplete() {
      s || j(!1);
    }
  }), y ? E : null;
});
process.env.NODE_ENV !== "production" && (W.displayName = "RadioIndicator");
const Ce = se({
  base: "",
  slots: {
    label: [
      "flex",
      "items-center",
      "gap-2",
      "cursor-pointer",
      "bg-white",
      "w-full"
    ],
    root: [
      "flex",
      "size-5",
      "items-center",
      "justify-center",
      "rounded-full",
      "outline-none",
      "focus-visible:outline",
      "focus-visible:outline-2",
      "focus-visible:outline-offset-2",
      "focus-visible:outline-blue-800",
      "data-[checked]:bg-primary-main",
      "data-[unchecked]:border",
      "data-[unchecked]:border-gray-300",
      "peer"
    ],
    indicator: [
      "flex",
      "before:size-2",
      "before:rounded-full",
      "before:bg-gray-50",
      "text-gray-700",
      "data-[checked]:text-white"
    ],
    rightIcon: ["hidden", "text-success-light", "peer-data-[checked]:block"]
  },
  variants: {
    variant: {
      default: {},
      options: {
        label: [
          "border",
          "p-3",
          "gap-x-4",
          "rounded-lg",
          "justify-between",
          "hover:bg-slate-50",
          "has-[:checked]:bg-gray-100"
        ],
        root: ["size-8", "rounded-md", "bg-gray-200"],
        indicator: ["before:hidden"]
      },
      card: {
        label: [
          "p-3",
          "gap-x-4",
          "rounded-lg",
          "border",
          "border-gray-300",
          "hover:bg-slate-50",
          "has-[:checked]:bg-gray-100",
          "has-[:checked]:border-primary-main"
        ]
      }
    }
  }
}), {
  label: Re,
  root: je,
  indicator: Ne,
  rightIcon: Ee
} = Ce(), Je = ({ label: e, description: r, ...l }) => {
  const c = re(), { variant: d, variantOptionLabel: m } = oe(), h = m === "number" ? c + 1 : String.fromCharCode(65 + c);
  return /* @__PURE__ */ t.jsxs(
    ne,
    {
      className: Re({ variant: d, class: "min-h-[2.625rem]" }),
      children: [
        /* @__PURE__ */ t.jsx(K, { ...l, className: je({ variant: d }), children: /* @__PURE__ */ t.jsx(
          W,
          {
            className: Ne({ variant: d }),
            keepMounted: !0,
            render: (u) => d === "options" ? /* @__PURE__ */ t.jsx("span", { ...u, children: h }) : /* @__PURE__ */ t.jsx("span", { ...u })
          }
        ) }),
        /* @__PURE__ */ t.jsxs("span", { className: "flex-grow", children: [
          /* @__PURE__ */ t.jsx("span", { children: e }),
          r && /* @__PURE__ */ t.jsx("span", { className: "text-sm text-gray-500 block", children: r })
        ] }),
        d === "options" && /* @__PURE__ */ t.jsx("span", { className: Ee({}), children: /* @__PURE__ */ t.jsx(ve, {}) })
      ]
    }
  );
};
export {
  Je as default
};
